export default "__VITE_ASSET__19467a60__"